import React from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import styles from "../ModalHelpDialog/ModalHelpDialog.module.scss";
import { Anfrage } from "domain/Types";
import { useFormikContext } from "formik";

type ModalAddressDialogProps = {
  showDialog: boolean;
  onClose: () => void;
};

const ModalAddressDialog: React.FC<ModalAddressDialogProps> = ({ showDialog, onClose: handleClose }) => {
  // stores
  // hooks
  const { setFieldValue } = useFormikContext<Anfrage>();

  // states
  // parameter
  // queries and mutations
  // effects
  // data
  // handler
  const handleSwitchToMapMode = () => {
    setFieldValue("projektstandort.karteAktiv", true);
    handleClose();
  };

  return (
    <Modal show={showDialog} onHide={handleClose} centered dialogClassName={styles.modal50w}>
      <Modal.Header closeButton className="px-4">
        <Modal.Title>Objekt nicht gefunden</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Row>
          <Col>
            Anhand Ihrer Adresseingabe konnte kein Objekt gefunden werden. Bitte setzen Sie den Marker in der Karte an
            die richtige Adresse.
          </Col>
        </Row>
        <Row>
          <Col>
            <span
              style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
              onClick={handleSwitchToMapMode}
            >
              Zum Kartenmodus wechseln
            </span>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="px-4">
        <Button onClick={handleClose}>Schließen</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddressDialog;
